import { render, staticRenderFns } from "./SharedAccountCreationPage.vue?vue&type=template&id=116a694c"
import script from "./SharedAccountCreationPage.vue?vue&type=script&lang=ts"
export * from "./SharedAccountCreationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports